<template>
  <div :class="wrapperClasses" @click="toggle">
    <div :class="inputClasses"/>
    <template v-if="$slots.default">
      <div class="og-checkbox__text"><slot/></div>
    </template>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    modelValue: {
      type: null,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    triState: {
      type: Boolean,
      default: false,
    },
    trueValue: {
      type: null,
      default: true,
    },
    falseValue: {
      type: null,
      default: false,
    },
    indeterminateValue: {
      type: null,
      default: null,
    },
  });

  const emit = defineEmits(['click', 'update:modelValue']);

  const isIndeterminate = computed(() => props.triState && props.modelValue === props.indeterminateValue);

  const inputClasses = computed(() => {
    const list = ['og-checkbox__checker'];

    if (isIndeterminate.value) {
      list.push('og-checkbox__checker--indeterminate');
    } else if (props.modelValue === props.trueValue) {
      list.push('og-checkbox__checker--checked');
    }

    return list;
  });

  const wrapperClasses = computed(() => {
    const list = ['og-checkbox'];

    if (props.readonly) {
      list.push('og-checkbox__checker--disabled');
    }

    return list;
  });


  function toggle() {
    if (props.readonly) {
      return;
    }

    emit('click');

    if (isIndeterminate.value) {
      emit('update:modelValue', props.trueValue);
      return;
    }

    if (props.modelValue === props.trueValue) {
      emit('update:modelValue', props.falseValue);
    } else {
      emit('update:modelValue', props.trueValue);
    }
  }
</script>
